import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import Button from "../Buttons";
import { useNavigate } from "react-router-dom";

const BookingDone = ({ guest,isSpinPromo,outletId }) => {
  let navigate = useNavigate();
  return (
    <BookingDoneContainer>
      <BookingSuccessText>{Text.bookingSuccess}</BookingSuccessText>
      <BookingdoneSubContainer guest={guest}>
        <BookingConfirmationDiv>
          <ConfirmationText>{Text.confirmationEmail}</ConfirmationText>
          <AddSpace>
            <Button
              label={isSpinPromo ? "Add More Tickets": "Back to Home Page"}
              variant="filled"
              color={Colors.aqua}
              size="large"
              padding="0.5rem 1.25rem"
              onClick={(e) => navigate(isSpinPromo ? `/app/booking/${outletId}`:"/auth/home")}
            />
          </AddSpace>
        </BookingConfirmationDiv>
        {guest && (
          <>
            <LineDiv />
            <ThankyouForbookingDiv>
              <ThankyouText>{Text.thankyouForBooking}</ThankyouText>
              <AddSpace>
                <Button
                  label="Sign Up"
                  variant="outlined"
                  color={Colors.aqua}
                  size="large"
                  padding="0.5rem 1.25rem"
                  onClick={(e) => navigate("/auth/signup")}
                />
              </AddSpace>
            </ThankyouForbookingDiv>
          </>
        )}
      </BookingdoneSubContainer>
    </BookingDoneContainer>
  );
};

const BookingDoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
`;
const BookingSuccessText = styled.span`
  color: ${Colors.darkRed};
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  @media only screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;
const BookingdoneSubContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: ${(props) => (props.guest ? "70%" : "100%")};
  margin-top: 1rem;
  padding: 0 1rem;
  box-sizing: border-box;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    margin-top: 0rem;
    align-items: center;
  }
`;
const BookingConfirmationDiv = styled.div`
  display: flex;
  width: ${(props) => (props.guest ? "50%" : "80%")};
  text-align: center;
  flex-direction: column;
  justify-content: space-around;
  align-items: ${(props) => (props.guest ? "none" : "center")};
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-top: 2rem;
    padding: 0 1rem;
    box-sizing: border-box;
  }
`;
const ThankyouForbookingDiv = styled(BookingConfirmationDiv)``;

const LineDiv = styled.div`
  height: inherit;
  border: 1px solid ${Colors.aqua};
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const ConfirmationText = styled.span`
  color: #4e4e4e;
  font-size: 1rem;
  font-weight: 600;
`;
const ThankyouText = styled(ConfirmationText)``;

const AddSpace = styled.div`
  margin-top: 1rem;
  width: ${(props) => (props.guest ? "auto" : "80%")};
  @media only screen and (max-width: 1024px) {
    width: '60%;
  }
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
`;
export default BookingDone;
